var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContentWithSidebar',{attrs:{"sections":_vm.sections,"groupKeys":_vm.groupKeys,"settings":_vm.settings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }